import { inject, Injectable } from "@angular/core";
import * as L from "leaflet";
import "leaflet.markercluster";
import { BaseMapComponentsService, IMarkerClusterParams } from "../MapComponentsBaseService";
import { NewDwellingMapMarkerComponent } from "src/app/map/map-marker/new-dwelling/new-dwelling-map-marker.component";
import { NewDwellingClusterMapMarkerComponent } from "src/app/map/map-marker/new-dwelling/new-dwelling-cluster-map-marker.component";
import { NewDwellingClusterPopupMarkerComponent } from "src/app/map/map-marker/new-dwelling/new-dwelling-cluster-popup.component";
import { IProjectStageDto } from "src/models/new-dwelling/new-dwelling.model";
import { NewDwellingSalesDataService } from "./new-dwelling-sales-data.service";

//Todo: se om noe av cluster-koden skal flyttes til en generell service eller hjelpeklasse
@Injectable()
export class NewDwellingMapComponentsService extends BaseMapComponentsService {
    private readonly newDwellingSalesDataService = inject(NewDwellingSalesDataService);
    
    constructor() {
        super();
        //this.mapActionsService.onMapClicked$.subscribe((click) => this.onNewDwellingMapClicked(click));
    }
    updateLayers(sales: IProjectStageDto[]) {
        if (this.layer) {
            this.layer.clearLayers();
        }

        if (sales == null) return;

        if (this.map) {
            this.layer = L.layerGroup().addTo(this.map);
            // if (sales.simplifiedSearch) {
            //     this.createOverviewMarkers(sales.data);
            // } else {
            this.createNewDwellingMarkers(sales);
            // }
        }
    }
    private createNewDwellingMarkerElement(sale: IProjectStageDto): HTMLElement {
        const [element, component] = this.createElementWithComponent(NewDwellingMapMarkerComponent);
        component.setInput("data", sale);
        return element;
    }
    private createNewDwellingMarker(sale: IProjectStageDto): L.Marker {
        const htmlElement = this.createNewDwellingMarkerElement(sale);
        const className = "commercial-marker";
        const lat = sale.latitude;
        const lng = sale.longitude;
        const originalObject = sale;
        return this.createMarker(lat, lng, htmlElement, className, originalObject);
    }

    private createOverviewMarker(sale: IProjectStageDto) {
        const icon = L.divIcon({
            html: "<div></div>",
            className: "overview-marker",
            iconSize: [30, 30],
        });
        const marker = L.marker([sale.latitude, sale.longitude], { icon: icon });
        (marker as any).originalObject = sale;
        return marker;
    }

    private createNewDwellingMarkers(estates: IProjectStageDto[]): void {
        const estateMarkers: any[] = [];

        estates.forEach((project) => {
            if (project.latitude != null && project.longitude != null) {
                const marker: L.Marker = this.createNewDwellingMarker(project);
                const popup: L.Popup = this.createNewDwellingMarkerPopup(project);

                marker.on('click', () => {
                    this.newDwellingSalesDataService.setSelectedStage(project);
                });

                estateMarkers.push(marker);
            }
        });

        const markerClusterParams: IMarkerClusterParams = {
            className: "map-cluster-wrapper new-dwelling-cluster",
            iconSize: [150, 22],
            markers: estateMarkers,
            targetEventListener: (e, t) => {},
            targetEvents: ["clusterclick", "clustermouseover", "clustermouseout"],
            chunkedLoading: true,
            maxClusterRadius: 110,
            spiderfyOnMaxZoom: false,
            zoomToBoundsOnClick: false,
        };
        this.createMarkerCluster(this.createMarkerClusterGroup(markerClusterParams), markerClusterParams);
    }
    private createOverviewMarkers(sales: IProjectStageDto[]): void {
        const estateMarkers: any[] = [];

        sales.forEach((item) => {
            if (item.latitude != null && item.longitude != null) {
                const marker: any = this.createOverviewMarker(item);
                estateMarkers.push(marker);
            }
        });

        this.createOverviewClusterGroup({
            className: "overview-marker",
            iconSize: [30, 30],
            markers: estateMarkers,
            targetEventListener: (e, t) => {},
            targetEvents: ["clusterclick", "clustermouseover", "clustermouseout"],
            chunkedLoading: true,
            maxClusterRadius: 110,
            spiderfyOnMaxZoom: false,
            zoomToBoundsOnClick: true,
        });
    }
    public createNewDwellingClusterElement(sales: IProjectStageDto[]): HTMLElement {
        const [element, component] = this.createElementWithComponent(NewDwellingClusterMapMarkerComponent);
        component.setInput("data", sales);
        return element;
    }

    private createMarkerClusterGroup(markerClusterParams: IMarkerClusterParams): L.MarkerClusterGroup {
        let sales: IProjectStageDto[] = [];
        let leaflet = this.getMarkerClusterGroup();

        const markerCluster = leaflet.markerClusterGroup({
            iconCreateFunction: (cluster: any) => {
                const markers = cluster.getAllChildMarkers();
                markers.forEach((m: any) => {
                    sales.push((m as any).originalObject);
                });
                const html = this.createNewDwellingClusterElement(sales);
                sales = [];
                return (L as any).divIcon({
                    iconSize: markerClusterParams.iconSize,
                    html: html,
                    className: markerClusterParams.className,
                    iconAnchor: [15, 15],
                });
            },
            showCoverageOnHover: true,
            polygonOptions: {
                color: "#3d91c6",
                weight: 2,
            },
            spiderfyOnMaxZoom: markerClusterParams.spiderfyOnMaxZoom,
            chunkedLoading: markerClusterParams.chunkedLoading,
            zoomToBoundsOnClick: markerClusterParams.zoomToBoundsOnClick,
            maxClusterRadius: () => {
                return markerClusterParams.maxClusterRadius;
            },
        });
        return markerCluster;
    }
    protected override openPopupForCluster(position: { lat: number; lng: number }, sales: any[]): void {
        const [htmlElement, component] = this.createElementWithComponent(NewDwellingClusterPopupMarkerComponent);
        component.setInput("data", sales);
        this.openPopupWithSales(htmlElement, sales?.length, position);
    }

    private createNewDwellingMarkerPopup(project: IProjectStageDto): L.Popup {
        const [htmlElement, component] = this.createElementWithComponent(NewDwellingClusterPopupMarkerComponent);

        component.setInput("data", [project]);

        return this.createMarkerPopup(htmlElement, "cluster-popup");
    }
}
